import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=3d44049a&"
import script from "./CustomSlider.vue?vue&type=script&lang=js&"
export * from "./CustomSlider.vue?vue&type=script&lang=js&"
import style0 from "./CustomSlider.vue?vue&type=style&index=0&id=3d44049a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports